export default "__VITE_ASSET__CIlzhv5G__"